// extracted by mini-css-extract-plugin
export default {"calcNumbers":"calculator_calcNumbers__TLUJf","calcClose":"calculator_calcClose__Yjlcj"};